import { render, staticRenderFns } from "./river.vue?vue&type=template&id=67b5eff8&scoped=true&"
import script from "./river.vue?vue&type=script&lang=js&"
export * from "./river.vue?vue&type=script&lang=js&"
import style0 from "./river.vue?vue&type=style&index=0&id=67b5eff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5eff8",
  null
  
)

export default component.exports